'use client';

import LLDropdown from '@next-app/components/elements/LLDropdown/LLDropdown';
import { FC, useEffect, useState, useMemo } from 'react';
import { selectCountries } from '@next-app/lib/features/checkout/CheckoutSelector';
import { useSelector } from 'react-redux';
import { Country } from '@next-app/lib/features/checkout/Checkout.interface';

interface Option {
  label: string;
  value: string;
}

interface CountryListProps {
  errorMsg?: string;
  automationId?: string;
  updateHandler?: Function;
  country?: string;
  onBlurHandler: Function;
}

const CountryList: FC<CountryListProps> = ({
  errorMsg,
  automationId,
  updateHandler,
  country,
  onBlurHandler,
}) => {
  const countries = useSelector(selectCountries) || [];

  const countryList = useMemo(() => {
    return (
      countries?.map((country: Country) => ({
        label: country.name,
        value: country.shortName,
      })) || []
    );
  }, [countries]);

  const [selectedCountry, setSelectedCountry] = useState(country);

  useEffect(() => {
    const defaultCountry =
      countries?.find(({ defaultCountry }) => defaultCountry === true)
        ?.shortName || '';
    if (!selectedCountry) {
      setSelectedCountry(defaultCountry);
    }
  }, [countries]);

  useEffect(() => {
    if (updateHandler && selectedCountry) {
      updateHandler({ country: selectedCountry });
    }
  }, [selectedCountry]);

  return (
    <LLDropdown
      options={countryList}
      labelText="Country"
      autoComplete="country"
      value={selectedCountry}
      onChange={(e) => {
        setSelectedCountry(e.target.value);
        if (updateHandler) {
          updateHandler({ country: e.target.value, state: '' });
        }
      }}
      errorMsg={errorMsg}
      onBlur={(e) => onBlurHandler(e)}
      automationId={automationId}
    />
  );
};

export default CountryList;
